import React from 'react';

/**
 * LoadingDots — GUIA
 * Tres puntos que laten en secuencia: "GUIA está pensando". Usan el color de
 * acción del tema (Orquídea en claro, Brote en oscuro).
 *
 * @param {number} size  Diámetro de cada punto en px.
 */
export default function LoadingDots({ size = 8, style, ...props }) {
  return (
    <span
      role="status"
      aria-label="Cargando"
      style={{ display: 'inline-flex', gap: 'var(--guia-space-2)', alignItems: 'center', ...style }}
      {...props}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            width: size, height: size, borderRadius: '50%', display: 'block',
            background: 'var(--guia-action)',
            animation: 'guia-dot-pulse 1.3s ease infinite',
            animationDelay: `${i * 0.18}s`,
          }}
        />
      ))}
    </span>
  );
}
